import Model from "../Model";

class Zoneinfo extends Model{

    buildUrl ({ param }) {
        return ['zoneview/infobyzoneid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Zoneinfo;